var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdb-logo-container"},[_c('img',{staticClass:"responsive",attrs:{"src":(_vm.publicPath + "2nomi-Logo-1.png"),"alt":"2nomi-Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }